import { render, staticRenderFns } from "./ArticleType.vue?vue&type=template&id=97e31398"
import script from "./ArticleType.vue?vue&type=script&lang=js"
export * from "./ArticleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports